// CallbackHandler.vue
<template>
  <!-- Optional: Ladeanzeige oder leeres Template -->
</template>
<script>
import Callback from '@/components/Callback';
import AuthenticationService from '@/services/AuthenticationService';

export default {
  mounted() {
    AuthenticationService.getUser().then(() => {
      if (!AuthenticationService.isAuthenticated)
        return AuthenticationService.callback();
    }).then(() => {
      if (AuthenticationService.redirectUri)
        location.replace(AuthenticationService.redirectUri);
      else
        location.replace('/');
    }).catch((e) => {
      if (e === 'unauthorized') {
        if (!AuthenticationService.isExternalIdentityProvider)
          setTimeout(() => { AuthenticationService.logout(); }, 5000);
        this.$router.push({ name: 'unauthorized' });
      }
      else
        this.$router.push({ name: 'signinfailed' });
    });
  },
  render() {
    return h(Callback); // return null;
  }
}
</script>
